import React from "react";
import {
  zAttrLabelMeta,
  zCurrencySignLocationCode,
  ZCurrencySignLocationCode,
} from "src/common/attributes/makeAttrLabel/types/ZAttrLabelMeta";
import { AttrTypeName } from "src/types/AttrType";
import { MakeLabelParams } from "../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../utils/getAttrLabelTreeData";

const joinSignMap: Record<
  ZCurrencySignLocationCode,
  (val: string, sign: string) => string
> = {
  [zCurrencySignLocationCode.Enum.signAfter]: (val: string, sign: string) =>
    `${val} ${sign}`,
  [zCurrencySignLocationCode.Enum.signBefore]: (val: string, sign: string) =>
    `${sign} ${val}`,
};
const getLabel = (code: ZCurrencySignLocationCode, val: string, sign: string) =>
  joinSignMap[code](val, sign);

export const makeFinancialLabel = (
  params: MakeLabelParams,
): React.ReactNode => {
  const treeData = getAttrLabelTreeData(params.attribute, params.labelTreeData);
  if (!treeData) return null;
  const meta = zAttrLabelMeta.parse(treeData.attrLabelMeta);
  if (meta.type !== AttrTypeName.financial) {
    throw Error("system error");
  }
  return getLabel(meta.signPosition, treeData.labels?.[0] || "", meta.sign);
};
